// `use:inview={onVisible}`: call back once, the first time the element
// scrolls into view (within any scrolling ancestor; the observer's implicit
// root clips by them), then stop watching. For deferring per-item work in a
// long list, such as the card options' set dropdown fetching one set symbol
// per row: Island lists 221 sets, and only the rows shown need theirs.
// Where IntersectionObserver is missing, the element counts as seen at once.

/**
 * @param {Element} node
 * @param {() => void} onVisible
 * @returns {{ destroy?: () => void }}
 */
export function inview(node, onVisible) {
  if (typeof IntersectionObserver === 'undefined') {
    onVisible();
    return {};
  }
  const io = new IntersectionObserver((entries) => {
    if (!entries.some((e) => e.isIntersecting)) return;
    io.disconnect();
    onVisible();
  });
  io.observe(node);
  return { destroy: () => io.disconnect() };
}
